// Static, verified site content for the PNG Landed Excellence preview.
// Contact details and credentials below were verified from public sources
// (pnglandedexcellence.com, CEA public register listings).

export const CONTACT = {
  agent: "Andy Cheng",
  role: "Senior Associate Group District Director",
  agency: "PropNex Realty Pte Ltd",
  ceaReg: "R012600H",
  agencyLicence: "L3008022J",
  phoneDisplay: "+65 9227 2638",
  phoneHref: "tel:+6592272638",
  whatsapp: "https://wa.me/6592272638",
  email: "andysgproperty@gmail.com",
};

export const NAV_LINKS = [
  { label: "Home", to: "/", hash: "" },
  { label: "About", to: "/", hash: "#about" },
  { label: "Buy / Sell", to: "/", hash: "#services" },
  { label: "Properties", to: "/properties", hash: "" },
  { label: "Insights", to: "/insights", hash: "" },
  { label: "Tools", to: "/tools", hash: "" },
  { label: "Contact", to: "/", hash: "#contact" },
];

export const PODCAST_URL = "https://www.pnglandedexcellence.com/podcast";

export const PODCAST_EPISODES = [
  { id: "W9JHepKZCAY", episode: "Episode 01", title: "An Introduction to Landed Properties in Singapore" },
  { id: "sPlc-o9etx4", episode: "Episode 02", title: "The 7 Must-Knows About URA Space When Buying Landed Properties" },
  { id: "6aqSL5sAQwI", episode: "Episode 03", title: "Landed Housing Setback Guidelines" },
];
export const LIVE_SITE_URL = "https://www.pnglandedexcellence.com/";

export const FRAMEWORK_STEPS = [
  {
    no: "01",
    title: "Discover",
    imageKey: "framework_2",
    text: "A structured consultation to map your goals, finances, timeline and the landed districts that genuinely fit.",
  },
  {
    no: "02",
    title: "Curate",
    imageKey: "property_4",
    text: "A handpicked shortlist of landed homes — filtered by land content, orientation, condition and potential, not portals.",
  },
  {
    no: "03",
    title: "Advise",
    imageKey: "insights_1",
    text: "Clear, data-informed counsel on value, stamp duties, risks and negotiation posture before you commit.",
  },
  {
    no: "04",
    title: "Secure",
    imageKey: "framework_1",
    text: "From option to completion — disciplined negotiation, documentation and aftercare, handled end to end.",
  },
];

export const BUYER_POINTS = [
  "Curated landed shortlists across all 24 landed districts",
  "Stamp duty and affordability planning before you offer",
  "Land content, zoning and rebuild-potential assessment",
  "Negotiation and option-to-purchase management",
];

export const SELLER_POINTS = [
  "Signature marketing system for landed homes",
  "Professional photography, film and staging direction",
  "Qualified buyer matching from an active landed network",
  "Weekly reporting and disciplined offer management",
];

export const HERO_STATS = [
  { value: "20+", label: "Years in real estate" },
  { value: "24", label: "Landed districts covered" },
  { value: "25+", label: "Landed curators on team" },
];

export const IRAS_LINKS = {
  bsd: "https://www.iras.gov.sg/taxes/stamp-duty/for-property/buying-or-acquiring-property/buyer's-stamp-duty-(bsd)",
  absd: "https://www.iras.gov.sg/taxes/stamp-duty/for-property/buying-or-acquiring-property/additional-buyer's-stamp-duty-(absd)",
};
